import { createSelector } from '@ngrx/store';

import { selectDashboardState } from '../dashboard.selectors';
import * as fromCategories from './category.reducer';

export const selectCategoryState = createSelector(selectDashboardState, (dashboard) => dashboard?.category);

export const selectCategories = createSelector(selectCategoryState, fromCategories.selectAll);

export const selectIsLoadingCategory = createSelector(
  selectCategoryState,
  (categoryState) => categoryState?.loadingCategory
);

export const selectCategoryLoaded = createSelector(
  selectCategoryState,
  (categoryState) => categoryState?.categoryLoaded
);
